import { axios, base } from '../http';

/**
 * 获取学校各校区主题班会配置
 * @param {Object} params { schoolId }
 */
export const getThemeClassMeetingConfigList = (params) => {
  return axios.get(`${base}/api/ThemeClassMeetingConfig/GetConfigList`, { params });
};

/**
 * 获取指定校区值日加分项级联树
 * @param {Object} params { schoolId, campusId }
 */
export const getThemeClassMeetingAdditionItemTree = (params) => {
  return axios.get(`${base}/api/ThemeClassMeetingConfig/GetAdditionItemTree`, { params });
};

/**
 * 保存某校区主题班会配置
 * @param {Object} data { schoolId, campusId, enabled, dutyInspectItemId }
 */
export const saveThemeClassMeetingConfig = (data) => {
  return axios.post(`${base}/api/ThemeClassMeetingConfig/SaveConfig`, data);
};

/**
 * 分页查询主题班会提交记录
 * @param {Object} params
 */
export const getThemeClassMeetingRecords = (params) => {
  return axios.get(`${base}/api/ThemeClassMeeting/GetRecords`, { params });
};

/**
 * 导出主题班会提交记录 Excel
 * @param {Object} params 与列表筛选一致（不含分页）
 */
export const exportThemeClassMeetingRecords = (params) => {
  return axios.get(`${base}/api/ThemeClassMeeting/ExportRecords`, { params, responseType: 'blob' });
};

/**
 * 作废主题班会记录
 * @param {Object} data { id, schoolId, reason }
 */
export const voidThemeClassMeetingRecord = (data) => {
  return axios.post(`${base}/api/ThemeClassMeeting/VoidRecord`, data);
};

/**
 * 某月完成汇总（支持分页）
 * @param {Object} params { schoolId, yearMonth, campusId, completionFilter, page, intPageSize }
 */
export const getThemeClassMeetingCompletionSummary = (params) => {
  return axios.get(`${base}/api/ThemeClassMeeting/GetCompletionSummary`, { params });
};

/**
 * 导出主题班会完成汇总 Excel
 * @param {Object} params 与汇总筛选一致（不含分页）
 */
export const exportThemeClassMeetingCompletionSummary = (params) => {
  return axios.get(`${base}/api/ThemeClassMeeting/ExportCompletionSummary`, { params, responseType: 'blob' });
};
